import styled from '@emotion/styled';
import { device, Icon } from '@landsbankinn/ui';
import React, { useRef } from 'react';
import { animated } from 'react-spring';

const Host = styled(animated.a)`
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  align-items: center;
  padding: 20px 30px;
  position: relative;
  cursor: pointer;
  span {
    transition: transform 200ms ease-in-out;
  }
  &:hover,
  &:focus {
    span {
      transform: translateY(-6px);
    }
  }
  @media ${device.tablet} {
    padding: 30px 10px;
  }
  @media ${device.desktop} {
    padding: 30px;
  }
`;

const IconWrap = styled.span`
  display: block;
  margin-bottom: 13px;
  @media ${device.tablet} {
    > svg {
      width: 100%;
    }
  }
`;

const HitArea = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  width: 100%;
  z-index: 1;
`;

const Text = styled.span`
  display: block;
  text-align: center;
  font-size: 14px;
  @media ${device.tablet} {
    font-size: 14px;
  }
  @media ${device.desktop} {
    font-size: 16px;
  }
`;

interface IProps {
  text: string | null | any;
  icon: string | any;
  link?: string | any;
  param?: string | any;
}

export const IconLink = ({ text, icon, ...rest }: IProps) => {
  const ref = useRef<HTMLSpanElement | null>(null);
  function dispatchEvent(name: string) {
    const obj = ref.current?.querySelector('object');
    if (obj && obj.contentDocument) {
      const svg = obj.contentDocument.querySelector('svg');
      if (svg) {
        svg.dispatchEvent(new Event(name));
      }
    }
  }
  return (
    <Host {...rest}>
      <HitArea
        onMouseEnter={() => dispatchEvent('mouseenter')}
        onMouseLeave={() => dispatchEvent('mouseleave')}
      />
      <IconWrap ref={ref}>{<Icon name={icon ?? 'facebook'} />}</IconWrap>
      <Text>{text}</Text>
    </Host>
  );
};
